import BaseClass from "../BaseClass.js";

export default class BlurEvent extends BaseClass {

    constructor(element) {
        super(element);

        this.actionUrl = null;
        this.postData = null;
        this.hasToastFeedback = false;
        this.toastType = null;
        this.toastTitle = null;
        this.toastSubtitle = null;
        this.toastBody = null;

        this.init();
    }


    init() {
        this.hasToastFeedback = this.$element.attr('data-toast-feedback');
        this.toastType = this.$element.attr('data-toast-type');
        this.toastTitle = this.$element.attr('data-toast-title');
        this.toastSubtitle = this.$element.attr('data-toast-subtitle');
        this.toastBody = this.$element.attr('data-toast-body');

        this.actionUrl = this.$element.attr('data-action-url');
        let postData = this.$element.val();

        if (postData.length > 0) {
            this.postData = postData;
        }

        let mySelf = this;
        this.blurListener = function () {
            mySelf.handleAction();
        };

        this.$element.on('blur', this.blurListener);
    }

    handleAction() {

        const mySelf = this;
        let postData = {};
        postData[this.$element.attr("name")] = this.$element.val();

        let jqxhr = $.post(this.actionUrl, postData, function () {
        }, 'json')
            .done(function (data) {
                if (mySelf.hasToastFeedback) {
                    $(document).trigger("toast:show", {
                        title: mySelf.toastTitle,
                        subtitle: mySelf.toastSubtitle,
                        body: mySelf.toastBody,
                        type: mySelf.toastType
                    });
                }
            });
    }

    destroyListener() {
        this.$element.off('blur', this.blurListener);
    }
}